//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

module.exports = {
  isLoggedIn: {
    "Marketing Admin": true,
    "Super Admin":true,
    "IT Admin": true,
    Accounting: true,
    "Sales Admin": true,
    "Observer":true
  },
  login: {
    Customer: true,
    "Loyalty Admin": true,
    "Consent Admin": true,
    "Customer Care": true,
    "Tele Sales": true,
    FSC: true,
    "Ecommerce Customer Service": true,
  },
  location: {
    "Marketing Admin": true,
    "Super Admin":true,
    "IT Admin": true,
    "Observer":true,
    Accounting: true,
    "Sales Admin": true,
  },
  loyalty: {
    Customer: false,
    "Loyalty Admin": false,
    "Consent Admin": true,
    "Customer Care": false,
    "Tele Sales": false,
    FSC: false,
    "Ecommerce Customer Service": false,
    "Marketing Admin": true,
    "Super Admin":true,
    "IT Admin": true,
    "Observer":true,
    Accounting: true,
    "Sales Admin": true,
  },
  redeem: {
    admins: {
      "Marketing Admin": true,
      "Super Admin":true,
      "IT Admin": true,
      "Observer":true,
      Accounting: true,
      "Sales Admin": true,
    },
    users: {
      Customer: true,
      "Loyalty Admin": true,
      "Consent Admin": true,
      "Customer Care": true,
      "Tele Sales": true,
      FSC: true,
      "Ecommerce Customer Service": true,
    },
  },
  myDashboard: {
    loyalty: {
      "Marketing Admin": true,
      "Super Admin":true,
      "IT Admin": true,
      "Observer":true,
      Accounting: true,
      "Sales Admin": true,
    },
    redeemBtn: {
      "Loyalty Admin": true,
      "Consent Admin": true,
      "Customer Care": true,
      "Tele Sales": true,
      FSC: true,
      "Ecommerce Customer Service": true,
    },
  },
  dashboard: {
    loyalty: {
      "Marketing Admin": true,
      "Super Admin":true,
      "IT Admin": true,
      "Observer":true,
      Accounting: true,
      "Sales Admin": true,
    },
    redeemBtn: {
      "Loyalty Admin": true,
      "Consent Admin": true,
      "Customer Care": true,
      "Tele Sales": true,
      FSC: true,
      "Ecommerce Customer Service": true,
    },
    changeLoyalty: {
      "Marketing Admin": true,
      "Super Admin":true,
      "IT Admin": true,
      "Observer":true,
      Accounting: true,
      "Sales Admin": true,
    },
  },
  authorizedMembers: {
    admins: {
      "Marketing Admin": true,
      "Super Admin":true,
      "IT Admin": true,
      "Observer":true,
      Accounting: true,
      "Sales Admin": true,
    },
  },
  sidebar: {
    changeLoyalty: {
      "Marketing Admin": true,
      "Super Admin":true,
      "IT Admin": true,
      "Observer":true,
      Accounting: true,
      "Sales Admin": true,
    },
  },
  auditView: {
    "IT Admin": true,
    "Observer":true,
    "Marketing Admin": true,
    "Super Admin":true,
  },
  editAccess:{
    
    "IT Admin":{
      "redeem":true,
      "authorized-members":true,
      "settings":true,
      "mpcdetail":true,
      "privilege":true,
      "overwrite":true,
      "ach-loyalty-points":true,
      "create-users":true,
      "max-merch":true,
      "approval":true,
      "email-logs":true,
      "tier-assignment":true,
      "create-promotion":true,
      "audit-config":true,
      "create-audit-config":true,
      "view-audit-config":true,
      "redemption-details":true,
      "member-details":true,
      "consentApproval":true,
      "view-promotion":true,
      "create-new-admin":true,
      "view-loyalty-account-shipto":true,
      "criteria-upload":true,
      "criteria-create":true,
      "range":true
  
      },
    "Observer":{
    "redeem":false,
    "authorized-members":false,
    "settings":false,
    "mpcdetail":false,
    "privilege":false,
    "overwrite":false,
    "ach-loyalty-points":false,
    "create-users":false,
    "max-merch":false,
    "approval":false,
    "email-logs":false,
    "tier-assignment":false,
    "create-promotion":false,
    "audit-config":false,
    "create-audit-config":false,
    "view-audit-config":false,
    "redemption-details":false,
    "member-details":false,
    "ConsentApproval":false,
    "view-promotion":false,
    "create-new-admin":false,
    "view-loyalty-account-shipto":false,
    "criteria-upload":false,
    "criteria-create":false,
    "range":false

    },
    "Customer":{
      "redeem":true,
      "authorized-members":true,
      "settings":true,
      "mpcdetail":true,
      "privilege":true,
      "overwrite":true,
      "ach-loyalty-points":true,
      "create-users":true,
      "max-merch":true,
      "approval":true,
      "email-logs":true,
      "tier-assignment":true,
      "create-promotion":true,
      "audit-config":true,
      "create-audit-config":true,
      "view-audit-config":true,
      "redemption-details":true,
      "member-details":true,
      "consentApproval":true,
      "view-promotion":true,
      "create-new-admin":true,
       "view-loyalty-account-shipto":true,
      "criteria-upload":true,
      "criteria-create":true,
      "range":true

  
      },
      "Loyalty Admin":{
        "redeem":true,
        "authorized-members":true,
        "settings":true,
        "mpcdetail":true,
        "privilege":true,
        "overwrite":true,
        "ach-loyalty-points":true,
        "create-users":true,
        "max-merch":true,
        "approval":true,
        "email-logs":true,
        "tier-assignment":true,
        "create-promotion":true,
        "audit-config":true,
        "create-audit-config":true,
        "view-audit-config":true,
        "redemption-details":true,
        "member-details":true,
        "consentApproval":true,
        "view-promotion":true,
        "create-new-admin":true,
        "view-loyalty-account-shipto":true,
        "criteria-upload":true,
        "criteria-create":true,
        "range":true
    
        },
        "Marketing Admin":{
          "redeem":true,
          "authorized-members":true,
          "settings":true,
          "mpcdetail":true,
          "privilege":true,
          "overwrite":true,
          "ach-loyalty-points":true,
          "create-users":true,
          "max-merch":true,
          "approval":true,
          "email-logs":true,
          "tier-assignment":true,
          "create-promotion":true,
          "audit-config":true,
          "create-audit-config":true,
          "view-audit-config":true,
          "redemption-details":true,
          "member-details":true,
          "consentApproval":true,
          "view-promotion":true,
          "create-new-admin":true,
          "view-loyalty-account-shipto":true,
          "criteria-upload":true,
          "criteria-create":true,
          "range":true
      
          },
          "Super Admin":{
            "redeem":true,
            "authorized-members":true,
            "settings":true,
            "mpcdetail":true,
            "privilege":true,
            "overwrite":true,
            "ach-loyalty-points":true,
            "create-users":true,
            "max-merch":true,
            "approval":true,
            "email-logs":true,
            "tier-assignment":true,
            "create-promotion":true,
            "audit-config":true,
            "create-audit-config":true,
            "view-audit-config":true,
            "redemption-details":true,
            "member-details":true,
            "consentApproval":true,
            "view-promotion":true,
            "create-new-admin":true,
            "view-loyalty-account-shipto":true,
            "criteria-upload":true,
            "criteria-create":true,
            "range":true
        
            },
          "Sales Admin":{
            "redeem":true,
            "authorized-members":true,
            "settings":true,
            "mpcdetail":true,
            "privilege":true,
            "overwrite":true,
            "ach-loyalty-points":true,
            "create-users":true,
            "max-merch":true,
            "approval":true,
            "email-logs":true,
            "tier-assignment":true,
            "create-promotion":true,
            "audit-config":true,
            "create-audit-config":true,
            "view-audit-config":true,
            "redemption-details":true,
            "member-details":true,
            "consentApproval":true,
            "view-promotion":true,
            "create-new-admin":true,
            "view-loyalty-account-shipto":true,
            "criteria-upload":true,
            "criteria-create":true,
            "range":true
        
            },
            "Customer Care":{
              "redeem":true,
              "authorized-members":true,
              "settings":true,
              "mpcdetail":true,
              "privilege":true,
              "overwrite":true,
              "ach-loyalty-points":true,
              "create-users":true,
              "max-merch":true,
              "approval":true,
              "email-logs":true,
              "tier-assignment":true,
              "create-promotion":true,
              "audit-config":true,
              "create-audit-config":true,
              "view-audit-config":true,
              "redemption-details":true,
              "member-details":true,
              "consentApproval":true,
              "view-promotion":true,
              "create-new-admin":true,
              "view-loyalty-account-shipto":true,
              "criteria-upload":true,
              "criteria-create":true,
              "range":true
          
              },
              "Tele Sales":{
                "redeem":true,
                "authorized-members":true,
                "settings":true,
                "mpcdetail":true,
                "privilege":true,
                "overwrite":true,
                "ach-loyalty-points":true,
                "create-users":true,
                "max-merch":true,
                "approval":true,
                "email-logs":true,
                "tier-assignment":true,
                "create-promotion":true,
                "audit-config":true,
                "create-audit-config":true,
                "view-audit-config":true,
                "redemption-details":true,
                "member-details":true,
                "consentApproval":true,
                "view-promotion":true,
                "create-new-admin":true,
                "view-loyalty-account-shipto":true,
                "criteria-upload":true,
                "criteria-create":true,
                "range":true
            
                },
                "FSC":{
                  "redeem":true,
                  "authorized-members":true,
                  "settings":true,
                  "mpcdetail":true,
                  "privilege":true,
                  "overwrite":true,
                  "ach-loyalty-points":true,
                  "create-users":true,
                  "max-merch":true,
                  "approval":true,
                  "email-logs":true,
                  "tier-assignment":true,
                  "create-promotion":true,
                  "audit-config":true,
                  "create-audit-config":true,
                  "view-audit-config":true,
                  "redemption-details":true,
                  "member-details":true,
                  "consentApproval":true,
                  "view-promotion":true,
                  "create-new-admin":true,
                  "view-loyalty-account-shipto":true,
                  "criteria-upload":true,
                  "criteria-create":true,
                  "range":true
              
                  },
                  "Accounting":{
                    "redeem":true,
                    "authorized-members":true,
                    "settings":true,
                    "mpcdetail":true,
                    "privilege":true,
                    "overwrite":true,
                    "ach-loyalty-points":true,
                    "create-users":true,
                    "max-merch":true,
                    "approval":true,
                    "email-logs":true,
                    "tier-assignment":true,
                    "create-promotion":true,
                    "audit-config":true,
                    "create-audit-config":true,
                    "view-audit-config":true,
                    "redemption-details":true,
                    "member-details":true,
                    "consentApproval":true,
                    "view-promotion":true,
                    "create-new-admin":true,
                    "view-loyalty-account-shipto":true,
                    "criteria-upload":true,
                    "criteria-create":true,
                    "range":true
                
                    },
                    "Consent Admin":{
                      "redeem":true,
                      "authorized-members":true,
                      "settings":true,
                      "mpcdetail":true,
                      "privilege":true,
                      "overwrite":true,
                      "ach-loyalty-points":true,
                      "create-users":true,
                      "max-merch":true,
                      "approval":true,
                      "email-logs":true,
                      "tier-assignment":true,
                      "create-promotion":true,
                      "audit-config":true,
                      "create-audit-config":true,
                      "view-audit-config":true,
                      "redemption-details":true,
                      "member-details":true,
                      "consentApproval":true,
                      "view-promotion":true,
                      "create-new-admin":true,
                      "view-loyalty-account-shipto":true,
                      "criteria-upload":true,
                      "criteria-create":true,
                      "range":true
                  
                      },
                      "Ecommerce Customer Service":{
                        "redeem":true,
                        "authorized-members":true,
                        "settings":true,
                        "mpcdetail":true,
                        "privilege":true,
                        "overwrite":true,
                        "ach-loyalty-points":true,
                        "create-users":true,
                        "max-merch":true,
                        "approval":true,
                        "email-logs":true,
                        "tier-assignment":true,
                        "create-promotion":true,
                        "audit-config":true,
                        "create-audit-config":true,
                        "view-audit-config":true,
                        "redemption-details":true,
                        "member-details":true,
                        "consentApproval":true,
                        "view-promotion":true,
                        "create-new-admin":true,
                        "view-loyalty-account-shipto":true,
                        "criteria-upload":true,
                        "criteria-create":true,
                        "range":true
                    
                        },
                        "Auditor":{
                          "redeem":true,
                          "authorized-members":true,
                          "settings":true,
                          "mpcdetail":true,
                          "privilege":true,
                          "overwrite":true,
                          "ach-loyalty-points":true,
                          "create-users":true,
                          "max-merch":true,
                          "approval":true,
                          "email-logs":true,
                          "tier-assignment":true,
                          "create-promotion":true,
                          "audit-config":true,
                          "create-audit-config":true,
                          "view-audit-config":true,
                          "redemption-details":true,
                          "member-details":true,
                          "consentApproval":true,
                          "view-promotion":true,
                          "create-new-admin":true,
                          "view-loyalty-account-shipto":true,
                          "criteria-upload":true,
                          "criteria-create":true,
                          "range":true
                      
                          }
  }

};
